module.exports = __webpack_public_path__ + "fonts/LatoLatin-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/ux-foundation/fonts/LatoLatin-Light.ttf
// module id = 1212
// module chunks = 1